import dataLayerPush, {
  DataLayerListenerArgs,
} from "@magalu/ecomm-components/rave/events/GA/utils/dataLayerPush";

import {
  COOKIE_CUSTOMER_SESSION_ID,
  COOKIE_CUSTOMER_INFO,
  ZIPCODE,
  ZIPCODE_CITY,
  ZIPCODE_STATE,
} from "@utils/constants/cookies";
import { getCityUf } from "@utils/getCityUf/getCityUf";

type PageViewProps = {
  eventId?: string;
  globalData: DataLayerListenerArgs<unknown>;
  value: {
    quantity_cards?: string;
    default_card?: string;
  };
};

export const pageViewCards = ({ globalData, value }: PageViewProps) => {
  const promoterId = globalData?.query?.promoter_id || undefined;
  const cookies = globalData.cookies || {};
  const customerSessionId =
    (cookies[COOKIE_CUSTOMER_SESSION_ID] as string) || "";
  const customerCookieInfo = (cookies[COOKIE_CUSTOMER_INFO] as string) || "";
  const customerId = customerSessionId || customerCookieInfo || undefined;
  const location = {
    zipCode: cookies[ZIPCODE],
    zipCodeCity: cookies[ZIPCODE_CITY],
    zipCodeState: cookies[ZIPCODE_STATE],
  };

  return dataLayerPush(() => ({
    barraLocalizacao: undefined,
    cartaoPadrao: value?.default_card || undefined,
    cepPreenchido: location.zipCode ? "1" : "0",
    cidadeuf: getCityUf(location.zipCodeCity, location.zipCodeState),
    event: "virtualPageview",
    idUsuario: customerId || undefined,
    loginAtivo: customerId ? "logado" : "nao-logado",
    mundos: "magalu",
    pageType: globalData?.route?.name,
    promoter_id: promoterId || undefined,
    quantidadeCartoes: value?.quantity_cards || undefined,
    screenName: globalData?.route?.name || undefined,
  }))({ globalData });
};
